(() => {
  const e = document.querySelector(".cookies-infobar");
  const n = document.querySelector("#cookies-infobar-close");
  const t = document.querySelector("#false");

  if (!e || !n || !t) {
    // якщо блок з куками або кнопки відсутні, просто виходимо
    return;
  }

  if (o()) {
    i();
    return;
  }

  function i() {
    e.className = e.classList.value + " cookies-infobar_accepted";
  }

  function o() {
    return "1" === r();
  }

  function r() {
    const name = "cookieInfoHidden=";
    const parts = document.cookie.split(";");
    for (let part of parts) {
      part = part.trim();
      if (part.indexOf(name) === 0) return part.substring(name.length, part.length);
    }
    return "";
  }

  function c(days) {
    const n = new Date();
    const t = n.getTime() + 864e5 * days;
    n.setTime(t);
    document.cookie = "cookieInfoHidden=1; expires=" + n.toUTCString() + "; path=/";
  }

  n.addEventListener("click", e => {
    e.preventDefault();
    i();
    c(7);
  });

  t.addEventListener("click", e => {
    e.preventDefault();
    i();
    c(7);
  });
})();
